import { PermissionsEnum } from "@/auth/interfaces";
import {  gridSize0, gridSizeMdLg12, ModulosEnumChoice, useCheckPermissions } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useEffect } from "react";
import TableReporteAgendamiento from "../../shared/componente/table_reporte_agendamiento/TableReporteAgendamiento";

export default function InformeInstalacionProgramadasVentasPage() {

  useCheckPermissions(PermissionsEnum.api_view_agendamiento);

  //STATE

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta;

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
  }, []);


  return (
    <SingleTableBoxScene
      title="Informe de Instalaciones Programadas y Resultados Diarios"
      gridSizeTitle={gridSizeMdLg12}
      gridSizeBtnAccion={gridSize0}
    >
      <TableReporteAgendamiento />
    </SingleTableBoxScene>
  )

}